import { BuyerRelationshipListParametersType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBuyerRelationshipCount = (
  params: BuyerRelationshipListParametersType,
  options?: ApiV2QueryOptions<number>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.BuyerRelationshipCount,
      params,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `buyer-relationships/count`,
        params,
      }).then((data) => apiV2AssertResponse<number>(data).data),

    ...getDefaultQueryOptionsV2({
      context: { scope: "buyer", user, business },
      options: options,
    }),
  });
};
